import * as React from "react";
import { Box, Stack, Typography, Checkbox } from "@mui/material";
import { BLUE_500, cardBoxSx, optionTextSx } from "../style";

type Props = {
  label: string;
  selected: boolean;
  onClick: () => void;
  "data-cy"?: string;
};

const RowCheckOption: React.FC<Props> = ({ label, selected, onClick, ...rest }) => (
  <Box
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
    sx={cardBoxSx(selected)}
    {...rest}
  >
    <Stack 
      direction="row" 
      alignItems="center" 
      justifyContent="flex-start"
      spacing={1.5}
      sx={{ height: "100%" }}
    >
      <Checkbox checked={selected} readOnly />
      <Typography sx={optionTextSx()}>{label}</Typography>
    </Stack>
  </Box>
);

export default React.memo(RowCheckOption);
